export const LOGO =
  "https://customer-assets-jai6qajn.emergentagent.net/job_scalp-solutions-8/artifacts/gbc06561_Hairprive%20Logo-02.png";

export const IMAGES = {
  trio:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_6c4446a6-4927-4bc1-8033-8d4c233f464b/artifacts/y6sqvx47_PHOTO-2026-08-04-19-03-10.jpg",
  argan:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_6c4446a6-4927-4bc1-8033-8d4c233f464b/artifacts/xhqe8kzs_PHOTO-2026-08-04-19-03-06%204.jpg",
  hairgrow:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_6c4446a6-4927-4bc1-8033-8d4c233f464b/artifacts/41uk3qjh_PHOTO-2026-08-04-19-03-07%202.jpg",
  dandruff:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_6c4446a6-4927-4bc1-8033-8d4c233f464b/artifacts/ueiyiq1p_PHOTO-2026-08-04-19-03-07.jpg",
  clinical:
    "https://images.unsplash.com/photo-1639772823849-6efbd173043c?crop=entropy&cs=srgb&fm=jpg&q=85",
  herbal:
    "https://images.pexels.com/photos/33410908/pexels-photo-33410908.jpeg",
  luxury:
    "https://images.unsplash.com/photo-1760647422523-f532034a49ce?crop=entropy&cs=srgb&fm=jpg&q=85",
};
